var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1359_2353",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1359_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1C6.39295 1 2 3.40554 2 6.47723V17.5228C2 20.5945 6.39295 23 12 23C17.6071 23 22 20.5945 22 17.5228V6.47723C21.9972 3.40554 17.6071 1 12 1ZM3.706 11.9203C3.706 11.479 3.89935 11.0378 4.28035 10.6051C4.40262 10.4684 4.46801 10.3005 4.48792 10.1325C6.30765 11.2598 8.97469 11.9601 12 11.9601C14.9969 11.9601 17.6469 11.2712 19.4637 10.1638C19.4979 10.3033 19.5604 10.4343 19.6628 10.5481C20.0807 11.0008 20.2912 11.462 20.2912 11.9231C20.2912 13.7052 16.8848 15.6923 11.9972 15.6923C7.10947 15.6923 3.706 13.7024 3.706 11.9203ZM12 2.70807C16.8877 2.70807 20.294 4.69513 20.294 6.47723C20.294 8.25932 16.8877 10.2492 12 10.2492C7.11231 10.2492 3.706 8.26216 3.706 6.47723C3.706 4.69229 7.11231 2.70807 12 2.70807ZM12 21.2948C7.11231 21.2948 3.706 19.3077 3.706 17.5228C3.706 17.0815 3.89935 16.6403 4.28035 16.2076C4.43958 16.0254 4.50782 15.7948 4.49076 15.5727C6.31049 16.6972 8.97754 17.3975 12 17.3975C14.9855 17.3975 17.6241 16.7143 19.441 15.6154C19.4524 15.8062 19.5235 15.9969 19.6628 16.1478C20.0807 16.6004 20.2912 17.0616 20.2912 17.5228C20.2912 19.3077 16.8877 21.2948 12 21.2948Z",
    fill: "#C0C2C9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/Data.0fe69dfc67bbc0c6dcc291d25958d472.svg";
export { ForwardRef as ReactComponent };